import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconChatText: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33746 18.1242C2.95663 18.1242 2.58678 17.9741 2.30678 17.6941C1.91178 17.3 1.77594 16.7275 1.95094 16.2008L2.65163 14.1167C2.73329 13.8608 2.72589 13.6041 2.63006 13.4016C2.13673 12.3408 1.87831 11.1659 1.87831 9.99919C1.87831 5.52002 5.52252 1.875 10.0017 1.875C14.4817 1.875 18.1259 5.51919 18.1259 9.99919C18.1259 14.4792 14.4817 18.1233 10.0017 18.1233C8.83585 18.1233 7.66089 17.8642 6.60589 17.3734C6.39922 17.2742 6.14089 17.2675 5.87672 17.3517L3.80255 18.0483C3.64838 18.0992 3.49163 18.1242 3.33746 18.1242ZM10.0009 3.125C6.21087 3.125 3.1275 6.20835 3.1275 9.99919C3.1275 10.985 3.34667 11.9775 3.76084 12.8692C3.99084 13.3533 4.02081 13.9358 3.83998 14.505L3.13665 16.5975C3.10165 16.7017 3.15496 16.7758 3.18996 16.8108C3.22496 16.8458 3.30002 16.8992 3.40419 16.8642L5.4859 16.165C6.0634 15.9808 6.64751 16.0092 7.13751 16.2433C8.02251 16.655 9.01504 16.8742 10.0009 16.8742C13.7917 16.8742 16.8751 13.7908 16.8751 10C16.8751 6.20917 13.7917 3.125 10.0009 3.125ZM13.9584 8.33333C13.9584 7.98833 13.6784 7.70833 13.3334 7.70833H6.66672C6.32172 7.70833 6.04172 7.98833 6.04172 8.33333C6.04172 8.67833 6.32172 8.95833 6.66672 8.95833H13.3334C13.6784 8.95833 13.9584 8.67833 13.9584 8.33333ZM11.4584 11.6667C11.4584 11.3217 11.1784 11.0417 10.8334 11.0417H6.66672C6.32172 11.0417 6.04172 11.3217 6.04172 11.6667C6.04172 12.0117 6.32172 12.2917 6.66672 12.2917H10.8334C11.1784 12.2917 11.4584 12.0117 11.4584 11.6667Z"
      fill={color}
    />
  </svg>
);

export default IconChatText;
